<div class="catalog-import">
  <h2 mat-dialog-title>IMPORT CATALOG · {{ data.vendorName || 'VENDOR' }}</h2>
  <mat-dialog-content>
    <p class="hint">
      Upload a vendor CSV or TSV. Column mapping is saved per vendor so the next
      import can reuse it. Excel workbooks can be added later once each vendor’s
      format is finalized. Catalog import never increases on-hand inventory.
    </p>

    <div class="meta">
      <span *ngIf="data.lastCatalogImportAt">
        Last import {{ formatDate(data.lastCatalogImportAt) }}
      </span>
      <span *ngIf="data.nextCatalogDueAt">
        · Next due {{ formatDate(data.nextCatalogDueAt) }}
      </span>
    </div>

    <div class="row">
      <mat-form-field>
        <mat-label>REFRESH EVERY (MONTHS)</mat-label>
        <input matInput type="number" min="1" [(ngModel)]="refreshMonths">
      </mat-form-field>
      <button mat-stroked-button type="button" (click)="saveRefreshOnly()">
        SAVE REFRESH INTERVAL
      </button>
      <label class="file-button">
        <input type="file" accept=".csv,.tsv,.txt,text/csv,text/tab-separated-values" (change)="onFileSelected($event)">
        CHOOSE CSV / TSV
      </label>
      <span *ngIf="file">{{ file.name }}</span>
    </div>

    <mat-progress-bar *ngIf="busy" mode="indeterminate"></mat-progress-bar>

    <ng-container *ngIf="step === 'map' || step === 'preview'">
      <div class="summary-title">FIELD MAP</div>
      <p class="hint">
        Match each AutoOptiq field to a column from this file. Required: model
        and a stable vendor key (SKU, UPC, or FPC).
      </p>
      <table class="map-table">
        <tr *ngFor="let field of fields">
          <td>
            {{ field.label }}
            <span *ngIf="field.required">*</span>
          </td>
          <td>
            <mat-select [(ngModel)]="fieldMap[field.key]" placeholder="—">
              <mat-option value="">—</mat-option>
              <mat-option *ngFor="let header of headers" [value]="header">
                {{ header }}
              </mat-option>
            </mat-select>
          </td>
        </tr>
      </table>
      <button mat-stroked-button type="button" [disabled]="busy" (click)="remap()">
        PREVIEW WITH THIS MAP
      </button>
    </ng-container>

    <ng-container *ngIf="preview?.preview && (step === 'preview' || step === 'done')">
      <div class="summary-title">PREVIEW</div>
      <p class="counts">
        New {{ preview.preview.counts.new }} ·
        Matched {{ preview.preview.counts.matched }} ·
        Changed {{ preview.preview.counts.changed }} ·
        Missing {{ preview.preview.counts.missing }} ·
        Duplicates {{ preview.preview.counts.duplicate }} ·
        Errors {{ preview.preview.counts.error }} ·
        Review {{ preview.preview.counts.review }}
      </p>

      <mat-checkbox
        [checked]="acceptAllChanges"
        (change)="toggleAcceptAll($event.checked)"
      >
        ACCEPT ALL VENDOR UPDATES
      </mat-checkbox>
      <p class="hint">
        Local quantity, retail price, notes, employee photos, and sales history
        are never overwritten. Only checked vendor changes are applied.
      </p>

      <div class="section" *ngIf="preview.preview.changed?.length">
        <div class="summary-title">CHANGED</div>
        <label class="change-row" *ngFor="let row of preview.preview.changed">
          <mat-checkbox [(ngModel)]="acceptKeys[row.key]"></mat-checkbox>
          <span>
            {{ row.mapped?.model }} {{ row.mapped?.colorCode || row.mapped?.color }}
            {{ row.mapped?.size }} · {{ changeSummary(row) }}
          </span>
        </label>
      </div>

      <div class="section" *ngIf="preview.preview.error?.length">
        <div class="summary-title">ERRORS</div>
        <div *ngFor="let row of preview.preview.error">
          Row {{ row.row }}: {{ row.error }}
        </div>
      </div>

      <div class="section" *ngIf="preview.preview.review?.length">
        <div class="summary-title">NEEDS REVIEW</div>
        <div *ngFor="let row of preview.preview.review">
          {{ row.mapped?.model }} {{ row.mapped?.size }} — {{ row.warning }}
        </div>
      </div>

      <div class="section" *ngIf="preview.preview.missing?.length">
        <div class="summary-title">MISSING FROM FILE</div>
        <div *ngFor="let row of preview.preview.missing">
          {{ row.mapped?.model }} {{ row.mapped?.colorCode || row.mapped?.color }}
          {{ row.mapped?.size }} — will be flagged, not deleted
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 'done' && result">
      <div class="summary-title">IMPORT RESULT</div>
      <p>
        Created {{ result.import?.totals?.created || 0 }},
        updated {{ result.import?.totals?.updated || 0 }},
        matched {{ result.import?.totals?.matched || 0 }},
        missing flagged {{ result.import?.totals?.missing || 0 }}.
      </p>
    </ng-container>

    <div class="summary-title">IMPORT HISTORY</div>
    <p *ngIf="!history.length">No catalog imports yet.</p>
    <table class="history-table" *ngIf="history.length">
      <tr *ngFor="let row of history">
        <td>{{ formatDate(row.dateAdded) }}</td>
        <td>{{ row.filename }}</td>
        <td>{{ row.employeeName }}</td>
        <td>
          +{{ row.totals?.created || 0 }} /
          ~{{ row.totals?.updated || 0 }} /
          !{{ row.totals?.missing || 0 }}
        </td>
        <td>{{ row.result }}</td>
      </tr>
    </table>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close(step === 'done')">
      {{ step === 'done' ? 'CLOSE' : 'CANCEL' }}
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      *ngIf="step === 'preview'"
      [disabled]="busy || !file"
      (click)="applyImport()"
    >
      CONFIRM IMPORT
    </button>
  </mat-dialog-actions>
</div>
